import { ChangeDetectorRef, Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { UserStore } from '@stores/user.store';
import { AppMessageService } from '../../../services/message.service';
import { CoronaOfficeAttendance } from '../../../entities/corona-office-attendance.entity';
import * as dayjs from 'dayjs';
import { CoronaService } from '../../../services/corona.service';
import { SpinnerService } from '../../../components/spinner/spinner.service';
import { SignatureComponent } from '@components/signature/signature.component';
import { HelperService } from '../../../services/helper.service';

@Component({
  selector: 'app-new-attendance-dialog',
  template: `
    <div class="flex items-center mb-1" mat-dialog-title style="margin-bottom:15px">
      <p class="flex-auto text-lg font-medium">New Office Attendance (Ruschenstr.)</p>
      <button mat-dialog-close mat-icon-button type="button">
        <mat-icon size="24px">close</mat-icon>
      </button>
    </div>

    <mat-dialog-content>

      <mat-form-field appearance="outline" class="block w-full">
      <mat-label>Date</mat-label>
      <input (click)="formDatepickerRef.open()"
             [matDatepicker]="formDatepickerRef"
             [(ngModel)]="dateToSet"
             [max]="today"
             matInput
             readonly>
      <mat-datepicker-toggle [for]="formDatepickerRef" matSuffix></mat-datepicker-toggle>
      <!--<mat-hint>Click on the input or the datepicker icon</mat-hint>-->
      <mat-datepicker #formDatepickerRef></mat-datepicker>
    </mat-form-field>

      <mat-form-field appearance="outline" class="block w-full">
        <mat-label>Start Hour</mat-label>
        <input [ngxMatTimepicker]="picker"
               [(ngModel)]="startHour"
               format="24"
               matInput
               readonly>
        <ngx-mat-timepicker #picker minutesGap="15"  defaultTime="08:00"></ngx-mat-timepicker> <!-- enableKeyboardInput="true" -->
        <mat-icon matSuffix class="icon-grey" style="margin-right:5px"
                  (click)="picker.open()">
          watch_later
        </mat-icon>
      </mat-form-field>

      <mat-form-field appearance="outline" class="block w-full">
        <mat-label>End Hour</mat-label>
        <input [ngxMatTimepicker]="picker2"
               [(ngModel)]="endHour"
               format="24"
               matInput
               readonly>
        <ngx-mat-timepicker #picker2 minutesGap="15" defaultTime="16:00"></ngx-mat-timepicker> <!-- enableKeyboardInput="true" -->
        <mat-icon matSuffix class="icon-grey" style="margin-right:5px"
                  (click)="picker2.open()">
          watch_later
        </mat-icon>
      </mat-form-field>

      <mat-form-field appearance="outline" class="block w-full">
        <mat-label>Comment (optional)</mat-label>
        <input matInput type="text" [(ngModel)]="attendance.comment"/>
      </mat-form-field>

      <app-signature></app-signature>

    </mat-dialog-content>

    <mat-dialog-actions>
      <span class="flex-1"></span>
      <button (click)="save()" color="primary" mat-flat-button type="button">
        <span>Save</span>
        <!--<ic-icon [icIcon]="icSend" [inline]="true" class="ml-2" size="16px"></ic-icon>-->
      </button>
    </mat-dialog-actions>
  `,
  styleUrls: [
  ],
  animations: [
  ],
  encapsulation: ViewEncapsulation.None
})
export class CoronaNewAttendanceDialogComponent implements OnInit {
  user = this.userStore.getUser();
  attendance: CoronaOfficeAttendance;
  today = new Date();
  dateToSet = new Date();
  startHour = '08:00';
  endHour = '16:00';

  @ViewChild(SignatureComponent)
  private signatureComponent!: SignatureComponent;

  constructor(private cd: ChangeDetectorRef,
              private dialogRef: MatDialogRef<CoronaNewAttendanceDialogComponent>,
              private userStore: UserStore,
              private appMessageService: AppMessageService,
              private coronaService: CoronaService,
              private spinner: SpinnerService,
              private helperService: HelperService,
  ) { }

  ngOnInit(): void {
    this.attendance = {
      startDate: new Date(),
      endDate: new Date(),
      comment: '',
    } as CoronaOfficeAttendance;
  }

  close() {
    this.dialogRef.close();
  }

  async save() {
    if (!this.signatureComponent.done()) {
      this.appMessageService.showInfoDialog('Please provide a signature');
    }
    else {
      let startDate = dayjs(this.dateToSet);
      let endDate = dayjs(this.dateToSet);
      startDate = startDate.hour(0);
      startDate = startDate.minute(0);
      startDate = startDate.second(0);
      startDate = startDate.millisecond(0);
      endDate = endDate.hour(0);
      endDate = endDate.minute(0);
      endDate = endDate.second(0);
      endDate = endDate.millisecond(0);

      startDate = startDate.add(parseInt(this.startHour.split(':')[0]), 'hours');
      startDate = startDate.add(parseInt(this.startHour.split(':')[1]), 'minutes');

      endDate = endDate.add(parseInt(this.endHour.split(':')[0]), 'hours');
      endDate = endDate.add(parseInt(this.endHour.split(':')[1]), 'minutes');

      const diffHours = endDate.diff(startDate, 'hours');
      const diffMinutes = endDate.diff(startDate, 'minutes');
      const diff = diffHours + ':' + (diffMinutes - (diffHours * 60));

      this.attendance.startDate = startDate.toDate();
      this.attendance.endDate = endDate.toDate();

      // Prevent time zones problems
      //this.attendance.attendanceDate = dayjs(this.attendance.attendanceDate).add(1, 'hours').toDate();

      this.attendance.signature = this.signatureComponent.returnImage();
      this.attendance.signature = await this.helperService.pngToJpg(this.attendance.signature);

      console.log('New Attendance', this.attendance);

      try {
        this.spinner.show();
        await this.coronaService.postAttendance(this.attendance);
        this.appMessageService.showToastSuccess('Stored ' + diff + ' hours');
        this.spinner.hide();
        this.close();
      } catch (e) {
        console.error(e);
        this.spinner.hide();
      }
    }
  }

}
